// extracted by mini-css-extract-plugin
export default {"form-field":"CustomerInfoFields-module__form-field--udRAl","customer-info-fields":"CustomerInfoFields-module__customer-info-fields--5fqAk"};